var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V72H0z",
    transform: "translate(-466 -452) translate(388 398) translate(40 54) translate(38)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B5FAAD",
    d: "M66.33 44.246L54 34.336v-20.66l12.33-9.924C68.726 1.836 72 3.805 72 7.14v33.72c0 3.347-3.285 5.303-5.67 3.387z",
    transform: "translate(-466 -452) translate(388 398) translate(40 54) translate(38) translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60E36B",
    d: "M0 42.025V5.975C0 2.675 2.675 0 5.975 0h36.05c1.585 0 3.104.63 4.225 1.75C47.37 2.87 48 4.39 48 5.975v36.05c0 3.3-2.675 5.975-5.975 5.975H5.975c-1.585 0-3.104-.63-4.225-1.75C.63 45.13 0 43.61 0 42.025z",
    transform: "translate(-466 -452) translate(388 398) translate(40 54) translate(38) translate(0 12)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b66b9fd1.svg";
export { ForwardRef as ReactComponent };